// Game balance config. All tunable numbers live here so non-engineers can
// tweak difficulty without touching scene logic.

export const config = {
  arena: {
    // Portrait 9:16 — designed for mobile, scales up cleanly on desktop.
    width: 540,
    height: 960,
    paddingX: 24,
    paddingY: 160, // leave room for taller stacked HUD up top
  },
  hud: {
    height: 160, // matches arena.paddingY
  },
  player: {
    speed: 200,
    radius: 16,
    dashMs: 280,
    dashSpeed: 480,
    dashCooldownMs: 900,
    iframeMs: 800,
    healthSegments: 5,
  },
  assets: {
    count: 5,                      // hidden assets distributed across hotspots at any time
    patchMs: 350,
    pickupRadius: 24,
    searchRadius: 46,
    searchMs: 250,
    scanMs: 1500,                  // scanner runtime before reveal
    exploitableRate: 0.65,         // chance a scanned asset is flagged exploitable
    exploitDurationMs: 5000,       // CVE hits → this long to patch before EXPLOITED
    roundResetSec: 15,             // searched-empty / dismissed hotspots silently re-seed this often
    // Full set per GAME_LOGIC.md. Each hidden asset is randomly assigned
     // one of these types when seeded into a hotspot.
    types: [
      'webserver',
      'domain',
      's3',
      'api',
      'database',
      'cloud',
      'cert',
      'subdomain',
      'email',
      'dns',
      'dataleak',
    ] as const,
  },
  cves: {
    spawnIntervalMs: [5000, 15000] as [number, number],
    speed: 220,
    lifetimeMs: 7500,
    radius: 12,
    firstSpawnDelayMs: 15000, // hands the player a 15s grace period to scope the room before the first wave
  },
  timers: {
    countdownSec: 120,
    bossCountdownSec: 45,
  },
  boss: {
    entryShakeMs: 1000,
    phase1DurationSec: 45,
    snippetIntervalStartMs: 5500,
    snippetIntervalDecayMs: 1000,
    snippetIntervalMinMs: 1000,
    exploitDurationMs: 5000,
    patchDurationMs: 2000,
    powerupPatchesRequired: 2,
    powerupActiveMs: 7000,                  // IONIX touch-deploy window after grab
    powerupTouchRadius: 55,                 // distance from hero centre to auto-WAF an item
    phase2TriggerUnshielded: 2,
    phase2SnippetsPerSec: 2,
    phase2DurationSec: 60,
  },
  scanner: {
    width: 96,
    height: 80,
  },
} as const;

export type AssetType = typeof config.assets.types[number];
